module.exports = __webpack_public_path__ + "static/media/48243218_2308762975865547_4372329157468618752_o-thumb.6967c21c.jpg";